export const Bio = {
  name: "Juan Andres Rojas",
  roles: [
    "Full-Stack Developer",
    "Mobile Developer",
    "UI/UX Designer",
    "AI Developer",
  ],
  description:
    "I am a motivated and versatile person, always ready to face new challenges. Passionate about learning, I am dedicated to delivering high-quality results. I possess a positive attitude and a growth mindset, which constantly drives me to improve and develop both personally and professionally.",
  github: "https://github.com/JuanRojasDev",
  resume: "https://drive.google.com/file/d/171_sTgnxImwGVgEDIaILz0B0mko0e9YQ/view?usp=sharing",
  resume_en: "https://drive.google.com/file/d/1CiLBtWyJ9Rxx-1AUw_R3hRajIYIoDDKM/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
  gmail: "https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=DXDwSWxClxbMhjMTtxqgXlxCSLBWRlZKgdDqMKnqvBqbQlWzpthjTBZqRBmwLrnrnrGQctQFGjHFJcrkxCRcWNpcHBQBRBjzbDqgRkTsMJQvtfpWKxcvVjHL",
};

export const skills = [
  {
    title: "Technical Skills",
    skills: [
      {
        name: "Ability to quickly and effectively learn new languages.",
        image:
          "https://cdn-icons-png.flaticon.com/512/11532/11532626.png",
      },
      {
        name: "Experience with development tools, frameworks, APIs, and libraries.",
        image:
          "https://cdn-icons-png.flaticon.com/512/11532/11532626.png",
      },
      {
        name: "Understanding software architecture and design effectively.",
        image:
          "https://cdn-icons-png.flaticon.com/512/11532/11532626.png",
      },
      {
        name: "Ability to understand and use third-party APIs.",
        image:
          "https://cdn-icons-png.flaticon.com/512/11532/11532626.png",
      },
      {
        name: "Knowledge of databases and use of different tools.",
        image:
          "https://cdn-icons-png.flaticon.com/512/11532/11532626.png",
      },
    ],
  },
  {
    title: "Soft Skills",
    skills: [
      {
        name: "Effective and clear communication skills.",
        image:
          "https://cdn-icons-png.flaticon.com/512/3062/3062533.png",
      },
      {
        name: "Ability to adapt to changes and solve problems.",
        image:
          "https://cdn-icons-png.flaticon.com/512/3062/3062533.png",
      },
      {
        name: "Creativity and ability to think of innovative and effective solutions.",
        image:
          "https://cdn-icons-png.flaticon.com/512/3062/3062533.png",
      },
      {
        name: "Ease of working in teams and leading work teams.",
        image:
          "https://cdn-icons-png.flaticon.com/512/3062/3062533.png",
      },
      {
        name: "Self-management and ability to work independently.",
        image:
          "https://cdn-icons-png.flaticon.com/512/3062/3062533.png",
      },
    ],
  },
];
export const frameworks = [
  {
    title: "languages",
    frameworks: [
      {
        name: "TypeScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "JavaScript",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Python",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "PHP",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
      },
      {
        name: "Dart",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
      },
    ],
  },
  {
    title: "frontend",
    frameworks: [
      {
        name: "React",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Next.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "Vue",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Astro",
        image: "https://astro.build/assets/press/astro-icon-light-gradient.svg",
      },
      {
        name: "HTML5",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS3",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
      },
    ],
  },
  {
    title: "backend",
    frameworks: [
      {
        name: "Node.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Express.js",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: "FastAPI",
        image: "https://cdn.worldvectorlogo.com/logos/fastapi.svg",
      },
      {
        name: "Laravel",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
      },
      {
        name: "GraphQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
      },
      {
        name: "JWT",
        image: "https://cdn.worldvectorlogo.com/logos/jwt-3.svg",
      },
      {
        name: "Redis",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
    ],
  },
  {
    title: "databases",
    frameworks: [
      {
        name: "MySQL",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "MongoDB",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "DynamoDB",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dynamodb/dynamodb-original.svg",
      },
      {
        name: "Supabase",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg",
      },
      {
        name: "Firebase",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      },
    ],
  },
  {
    title: "mobile",
    frameworks: [
      {
        name: "Flutter",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
      },
      {
        name: "React Native",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Android Studio",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original.svg",
      },
    ],
  },
  {
    title: "ai",
    frameworks: [
      {
        name: "OpenAI",
        image: "https://cdn.worldvectorlogo.com/logos/openai-2.svg",
      },
      {
        name: "Gemini",
        image: "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg",
      },
      {
        name: "Claude",
        image: "https://media.lantern.io/claude_logo_3ec57d87f2.svg",
      },
      {
        name: "Pandas",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg",
      },
      {
        name: "Ollama",
        image: "https://avatars.githubusercontent.com/u/151674099?s=200&v=4",
      },
      {
        name: "n8n",
        image: "https://avatars.githubusercontent.com/u/45487711?s=200&v=4",
      },
      {
        name: "Make",
        image: "https://images.ctfassets.net/dm4oa8qtogq0/4LP1ix40a63dpOPZhila2Z/6d22ac51f33854d1e759e0f5fa3dd210/make-app-icon-circle.png",
      },
    ],
  },
  {
    title: "devops",
    frameworks: [
      {
        name: "Docker",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      },
      {
        name: "GitHub Actions",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/githubactions/githubactions-original.svg",
      },
      {
        name: "Linux",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
      },
      {
        name: "AWS",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Google Cloud",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg",
      },
      {
        name: "Vercel",
        image: "https://assets.vercel.com/image/upload/v1588805858/repositories/vercel/logo.png",
      },
    ],
  },
  {
    title: "tools",
    frameworks: [
      {
        name: "Git",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "RabbitMQ",
        image: "https://www.rabbitmq.com/assets/files/rabbitmq-logo-e91cacd38fcef5219149bc5cfa10b384.svg",
      },
      {
        name: "Jenkins",
        image: "https://docs.device42.com/assets/images/Jenkins-logo-butler-transparent-9eb4225eb2cc214e61c9f37e0870ecc3.png",
      },
      {
        name: "VS Code",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      {
        name: "Figma",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      },
      {
        name: "Notion",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/notion/notion-original.svg",
      },
      {
        name: "Jira",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://pbs.twimg.com/media/GLd3SqLWQAAvDQ2?format=png&name=small",
    role: "Diseñador Web, Desarrollador Frontend",
    company: "InnovaHogarTV",
    date: "1 Mar 2021 - 30 May 2022",
    desc: "• Desarrollé un sitio web de comercio electrónico utilizando React JS, HTML, CSS y JavaScript para una empresa dedicada a productos para el hogar. Me enfoqué en mejorar la experiencia del usuario mediante una interfaz altamente interactiva y responsive. Los usuarios podían explorar productos fácilmente y contactar directamente con la empresa gracias a una navegación intuitiva y componentes optimizados.",
    skills: [
      "ReactJs",
      "NodeJs",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
  {
    id: 1,
    img: "https://pbs.twimg.com/media/GLd1l9lWAAETep2?format=png&name=small",
    role: "Desarrollador Fullstack",
    company: "Snake Meta",
    date: "10 Nov 2023 - 25 Nov 2024",
    desc: "• Experiencias de usuario mejoradas utilizando Flutter y Hive. Construí la autenticacion utilizando JWT con una interacción perfecta de las API REST utilizando FastAPI optimizado con Python y Flask. Con el Código se exporto a Android e IOS, actualizado con nuevas dependencias e integrando SQLAlchemy con SQLite para la base de datos. Se implemento Georeferenciacion con la API de Google Maps",
    skills: [
      "Python",
      "Flask",
      "FastAPI",
      "Flutter",
      "SQLAlchemy",
      "Hive",
      "Firebase",
      "Google Maps API",
    ],
  },
  {
    id: 2,
    img: "https://i.postimg.cc/k4B9zXWQ/GLd2O8TW8AAi6Hl.png",
    role: "Desarrollador Móvil, Depuración, Redacción de nuevas ideas, Redacción de nuevas funciones.",
    company: "Aktua",
    date: "13 Feb 2024 - 18 May 2024",
    desc: "• Desarrollé una PWA utilizando Python, donde implementé Poetry, Uvicorn integrado con Flask y FastAPI, y manejé las consultas a la base de datos PostgreSQL mediante SQLAlchemy. Además, diseñé la arquitectura de alto nivel y los diseños de interfaz utilizando ProtoPie Cloud. En el backend, utilicé Flask y FastAPI para crear endpoints eficientes y seguros, implementando autenticación JWT para la seguridad del usuario. Logré reducir las llamadas a la API en un 20% mediante optimizaciones en el código y la base de datos. Dockericé la aplicación para facilitar su despliegue y la automatización de procesos.",
    skills: [
      "Docker",
      "Python",
      "Flask",
      "SQLAlchemy",
      "FastAPI",
      "PostgreSQL",
      "ProtoPie",
      "Flutter",
      "JWT",
    ],
  },
  {
    id: 3,
    img: "https://scontent.fbog3-1.fna.fbcdn.net/v/t39.30808-6/322350027_668401021750139_7431642920217974754_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=QDtAvbpawcwQ7kNvwGoWOEj&_nc_oc=AdofxpgN4A-fVb1BNROcYor8YjyS9ac0U12Q-hzK7wD8vQzBbitEZay5BWYYL2jKof4&_nc_zt=23&_nc_ht=scontent.fbog3-1.fna&_nc_gid=B-CNTgY28-Damhw7cFdaFg&_nc_ss=7b289&oh=00_Af7td6dB1vPyrCxKoRNebU-I1GiWtht1chk4HICjDwBMPw&oe=6A073439",
    role: "Desarrollador Web Full Stack",
    company: "BodyTech y Athletic Gym",
    date: "27 Mar, 2025 - 19 Ene, 2026",
    desc: "• Desarrollé aplicaciones web con PHP (Phalcon) y React, creando APIs REST, autenticación RBAC y módulos internos seguros. Integré PQRS con web, WhatsApp Business API y correo, automaticé procesos clave y optimicé consultas backend, reduciendo tiempos de carga en más del 30%.",
    skills: [
      "React",
      "PHP",
      "Phalcon",
      "REST API",
      "RBAC",
      "MySQL",
      "AWS",
      "Docker",
      "Git",
      "Jira",
      "JavaScript",
    ],
  },
  {
    id: 4,
    img: "https://avatars.githubusercontent.com/u/58649082?s=200&v=4",
    role: "Desarrollador Android",
    company: "Google Developers Student Club (GDSC) KIIT",
    date: "12 Mar, 2024",
    desc: "Como desarrollador de Android tome la iniciativa de particiar en Google Developers Student Club (GDCS), teniendo la oportunidad de trabajar en proyectos interesantes y colaborar con desarrolladores talentosos que comparten mi pasión por la tecnología. A través de mi participación en GDCS, también tuve la oportunidad de participar en numerosos eventos, incluidos hackathons, Study Jams y talleres.",
    skills: [
      "Leadership",
      "Teamwork",
      "Mobile Application Development",
      "Flutter",
      "XML",
      "Figma",
      "Android Studio",
    ],
  },
  {
    id: 5,
    img: "https://pbs.twimg.com/media/GLd3qwaXUAEOfDr?format=png&name=small",
    role: "Contribuidor de Código Abierto",
    company: "Github Contributor of Code",
    date: "12 Mar 2023 - Present",
    desc: "Contribuyo actualmente a proyectos de código abierto, colaborando con desarrolladores de diferentes partes del mundo y fortaleciendo buenas prácticas de desarrollo.",
  },
];

export const projects = [
  {
    id: 0,
    title: "AITEC - Sitio Web Corporativo",
    date: "Ene 2026 - Mar 2026",
    description:
      "Desarrollé el sitio web corporativo completo para AITEC, una empresa líder en soluciones ambientales. El proyecto incluyó diseño responsivo, optimización SEO, integración de formularios de contacto y secciones informativas sobre servicios y productos. Implementé una experiencia moderna y profesional alineada con la identidad de la marca.",
    image:
      "https://i.ibb.co/qMT4nS7D/Aitec-Website.png",
    tags: [
      "HTML",
      "CSS",
      "JavaScript",
      "Next.js",
      "React",
    ],
    category: "web app",
    github: "",
    webapp: "https://aitec.com.co/",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },

  {
    id: 1,
    title: "Inventario Cardex Automotriz",
    date: "Abr 2026 - May 2026",
    description:
      "Sistema de gestión de inventario automotriz desarrollado con tecnologías modernas. Permite el control completo de piezas, repuestos y vehículos con funcionalidades de registro, búsqueda avanzada, reportes y seguimiento de stock. Implementa autenticación de usuarios, roles y permisos para gestión segura del inventario. Incluye dashboard con métricas en tiempo real y alertas de stock bajo.",
    image:
      "https://i.ibb.co/v6ttfrzW/Kardex.png",
    tags: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "Material UI",
      "JWT",
    ],
    category: "web app",
    github: "https://github.com/JuanRojasDev/inventario-cardex",
    webapp: "https://frontend-aktua.vercel.app/",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },
  {
    id: 2,
    title: "Snake Meta",
    date: "Nov 2023 - Nov 2024",
    description:
      "The Mobile Application is planned to be launched on Playstore in November 2024. This project proposes the 'Development of a Mobile Application to prevent, inform, and preserve the different species of snakes in Meta'. It keeps a record of all the snakes in the Department through an API with their Taxonomy, Data, Information, and Georeferencing. It has the Google Maps API to georeference the snake in the user room database. Made with Flutter in MVVM Architecture and Live Data.",
    image:
      "https://i.ibb.co/ffbchB6/1710953065501.jpg",
    tags: [
      "Python",
      "FastAPI",
      "Flutter",
      "SQLAlchemy",
      "Hive",
      "Firebase",
      "Google Maps API",
    ],
    category: "mobile app",
    github: "https://github.com/JuanRojasDev/Snake-Meta/tree/main",
    webapp: "https://drive.google.com/file/d/1_r6n5F9CfS1D_fHqH1YTVAttY6iJlGXn/view?usp=sharing",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },
  {
    id: 3,
    title: "Aktua",
    date: "Feb 2024 - May 2024",
    description:
      "Developed a PWA (Progressive Web Application) in a Scrum framework with the aim of creating and fostering united, safe, and collaborative neighborhood communities. Used Python to connect with FastAPI, Uvicorn, Poetry services, and SqlAlchemy for database connection with PostgreSQL. Created services for Posts, Comments, and Ratings for users and Dockerized the project to make it cross-platform. With Flutter, we created the application for mobile devices, making it compatible with iOS and Android.",
    image:
      "https://i.ibb.co/rDfB3Hh/1710960857056.jpg",
    tags: [
      "Docker",
      "Python",
      "SQLAlchemy",
      "FastAPI",
      "PostgreSQL",
      "ProtoPie",
      "Flutter",
      "JWT",
    ],
    category: "mobile app",
    github: "https://github.com/Aktua-co",
    webapp: "https://cloud.protopie.io/p/9e25b9516ea6b9c252f5179d",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
      {
        name: "Camila Santacruz",
        img: "https://avatars.githubusercontent.com/u/30128960?v=4",
        linkedin: "https://www.linkedin.com/in/camila-santacruz-72a513159/",
        github: "https://github.com/milasantacruz",
      },
    ],
  },
  {
    id: 4,
    title: "UEFA Champions League Bracket",
    date: "May 2026 - May 2026",
    description:
      "Pronóstico interactivo para la UEFA Champions League. Permite arrastrar equipos entre rondas y armar, de forma simple, quién crees que gana cada cruce hasta llegar al campeón.",
    image:
      "https://i.ibb.co/RG4vPKXV/mi-bracket-champions-league-1.png",
    tags: [
      "JavaScript",
      "React",
      "HTML",
      "CSS",
      "API Integration",
    ],
    category: "web app",
    github: "https://github.com/JuanRojasDev/uefa-champions-league-bracket",
    webapp: "https://uefa-champions-league-bracket.vercel.app/",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },
  {
    id: 5,
    title: "Landing Page Unillanos",
    date: "May 2024 - Jun 2024",
    description:
      "Designed and developed a Landing Page with Astro, Tailwind CSS, and Material UI, it is a web page dedicated to acknowledgments for our graduation of study companions. I implemented a creative design where you can see the acknowledgment speech in several languages, English and Spanish, and I also implemented a photo carousel of the students who will graduate. I followed up on the landing page to improve the effectiveness and warmth of the project.",
    image:
      "https://i.ibb.co/xbr5HwF/speechunillanos.png",
    tags: [
      "Astro",
      "HTML",
      "CSS",
      "JavaScript",
      "Tailwind CSS",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/JuanRojasDev/landing-page-unillanos",
    webapp: "https://acknowledgment-c1.vercel.app/",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },
  {
    id: 6,
    title: "Brain Tumor Detection",
    date: "Jan 2023 - Mar 2023",
    description:
      "Supported a Web Application which preprocessed and augmented the dataset to improve model accuracy, trained the model, improved the API using the model and Python, and used the React web application for the project interface. Achievements: Achieved 99.2% accuracy in accurately detecting brain tumors from medical images.",
    image:
      "https://i.ibb.co/C3ytVB25/314571746-55a41049-970d-43d0-adad-5f4d97d40ac6.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/JuanRojasDev/Brain-Tumor-Detection/tree/main",
    webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Juan Andres Rojas",
        img: "https://i.ibb.co/n83kbthZ/114270458.jpg",
        linkedin: "https://www.linkedin.com/in/juan-andres-rojas-salinas-2a74b31bb/",
        github: "https://github.com/JuanRojasDev",
      },
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2A_43LS8NI2rkZbfHG_SV2FwWqwKy2Zk4i-pJ8Lnjl-2ElPBv0uGtxvGlTQ3cpl3MWtc&usqp=CAU",
    school: "Colegio Rembrandt",
    degree: "Bachillerato con Enfasís Empresarial",
    date: "Feb 2016 - Nov 2021",
    grade: "100%",
    desc: "Me gradué de bachillerato en 2021 del colegio Rembrandt en Bogotá, Colombia. Durante mi tiempo en esta institución, no solo adquirí conocimientos académicos, sino que también cultivé valores fundamentales que han moldeado mi carácter y guiado mis acciones. Aprendí el valor de la responsabilidad al cumplir con mis deberes escolares y participar activamente en actividades extracurriculares. La honestidad se convirtió en un pilar central en mi vida al ser transparente en mis acciones y relaciones. La empatía floreció en mí al entender las perspectivas de mis compañeros y brindar apoyo cuando era necesario.",
    skills: [
      "Comunicación Efectiva",
      "Empatía",
      "Resolución de Conflictos",
      "Habilidades de Negociación",
      "Gestión de Emociones",
    ],
  },
  {
    id: 1,
    img: "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/092015/logo_minuto_de_dios.png?itok=JYHlyDUc",
    school: "Corporación Universitaria Minuto de Dios sede San Juan Eudes",
    degree: "Tecnólogo En Desarollo de Software",
    date: "Feb 2022 - Nov 2024",
    grade: "100%",
    desc: "Tecnólogo en formación en Desarrollo de Software en la Corporación Universitaria Minuto de Dios. Durante mi tiempo en la universidad, he adquirido una sólida comprensión de los principios fundamentales del desarrollo de software y técnicas avanzadas para la creación de aplicaciones innovadoras. Mi enfoque en el desarrollo de software me permitió alcanzar el quinto semestre de mi programa académico, lo que me brindó una base sólida en áreas como programación, diseño de bases de datos y desarrollo de aplicaciones web y móviles.",    
    skills: [
      "Liderazgo en Proyectos",
      "Diseño de Bases de Datos",
      "Desarollo de Aplicaciones Web",
      "Resolución de Problemas",
      "Trabajo en Equipo",
    ],
  },
  {
    id: 2,
    img: "https://pbs.twimg.com/media/GLd4HW_XAAAsoy7?format=jpg&name=medium",
    school: "Centro de Idiomas - Unillanos",
    degree: "English Advanced C1",
    grade: "C1",
    date: "Feb 2022 - Jun 2024",
    desc: "Durante mi tiempo en el Centro de Idiomas - Unillanos, estoy completando el programa de English Advanced C1, alcanzando el nivel C1 en inglés. Esta experiencia me ha proporcionado habilidades avanzadas en comprensión auditiva, expresión oral, lectura y escritura en inglés. Estoy capacitado para comunicarme efectivamente en diversos entornos académicos, profesionales y sociales en inglés.",
    skills: [
      "Speaking",
      "Writing",
      "Reading",
      "Listening",
      "Grammar",
    ],
  },
];
